import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Box, Button, Modal, TextField, InputLabel } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import IconCancel from "src/assets/images/icon_cancel.svg";
import { DispatchForm } from "./add";
import { Loader } from "src/components/loader";
import IconTruckLoad from "src/assets/images/icon_truckload.svg";
import IconApproveDoc from "src/assets/images/icon_approvedoc.svg";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import { LoadOrderForm } from "./loadOrder";
import FinalDeliveryForm from "./finalDelivery";
import IconError from "src/assets/images/icon_error.svg";
import { toast } from "react-toastify";
import IconDownload from "src/assets/images/icon_download.svg";
import IconSubmit from "src/assets/images/icon_submit.svg";
import toastMessages from "src/constant/toastMessages.json";
import {
  getDispatchOrderByIdAction,
  editDispatchOrder,
  saveNewLaodInData,
  deleteDeliveryOrderRecord,
} from "src/thunks/dispatchOrder";
import html2pdf from "html2pdf.js";
import SigmaLogo from "src/assets/images/S1GMA_Logo.png";
import PrintPdfComponent from "./PrintPdf";
import { Addremarks } from "src/thunks/goodsin";
import {
  GetError,
  AddingZeroOnTime,
  getFloatValue,
  tConvert,
  convertIsoToLocalDateTime,
} from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";
import DeleteIcon from "@mui/icons-material/Delete";
import UploadDoc from "src/components/UploadDocumentModal";
import UploadIcon from "@mui/icons-material/Upload";
import { PDFDownloadLink } from "@react-pdf/renderer";

export const Details = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const lookupValues = useSelector((state) => state.lookup.data);
  const { goodsData, getByIdDispatchOrderLoadingState, ...rest } = useSelector(
    (state) => state.dispatch
  );

  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = useState(false);
  const [openCancelModel, _openCancelModel] = useState(false);
  const [openApprovedModel, _openApprovedModel] = useState(false);
  const [deleteRecordModal, _deleteRecordModal] = useState(false);
  const [loadOrderModal, _loadOrderModal] = useState(false);
  const [finalDeliveredModal, _finalDeliveredModal] = useState(false);
  const [dispatchDetailsData, _dispatchDetailsData] = useState({});
  const [allDispatchItem, _allDispatchItem] = useState([]);
  const [isUpdateShow, setIsUpdateShow] = useState(false);
  const [vehicalData, setVehicalData] = useState([]);
  const [ActiveIndex, setActiveIndex] = useState(0);
  const [
    checkAllAvailableDataIsDispatched,
    setCheckAllAvailableDataIsDispatched,
  ] = useState(false);
  const [showRemark, setShowRemark] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [openDocumentModel, setOpenDocumentModal] = useState(false);
  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  }
  const DocumentModalStyle = {
    position: "absolute",
    top: "50%",
    left: "46%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "70%",
    bgcolor: "background.paper",
    overflowY: "scroll",
  };
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "46%",
    transform: "translate(-50%, -50%)",
    width: "77%",
    height: "100%",
    bgcolor: "background.paper",
    overflowY: "scroll",
  };
  const handleClosemodal = () => {
    // setItemDataForShowImage(null)
    setOpenDocumentModal(false);
  };
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      comments: "",
    },
    resolver: yupResolver(
      yup.object().shape({
        comments: yup.string().required("Remarks is rquired"),
      })
    ),
  });

  /** variable declarations ----------------------------------------------------- **/
  let statusflag = "#0045D9";
  let { id } = useParams();
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));
  let getIndividualDispatchOrderDataMod = {
    ...rest.getIndividualDispatchOrderData,
  };
  let remarks = getIndividualDispatchOrderDataMod.deliveryOrderRemarks;
  const deliveryItems = getIndividualDispatchOrderDataMod?.deliveryItems || [];
  let ActiveData = vehicalData.length > 0 ? vehicalData[ActiveIndex] : {};
  let damageCount =
    _.filter(deliveryItems, (d) => d.conditionId === 24)?.length || 0;
  let unitsCount = _.sumBy(deliveryItems, (d) => d.quantity) || 0;
  let damageCountForDispatch =
    _.filter(ActiveData?.items || [], (d) => d.condition === "Damaged")
      ?.length || 0;
  let unitsCountForDispatch = _.sumBy(
    allDispatchItem,
    (d) => d.quantityDispatched
  );
  let internalSpaceCountForDispatch = getFloatValue(
    _.sumBy(
      _.filter(ActiveData?.items, (d) => d?.storageId === 21) || [],
      (d1) => d1.spaceReleased
    )
  );
  let externalSpaceCountForDispatch = getFloatValue(
    _.sumBy(
      _.filter(ActiveData?.items, (d) => d.storageId === 22) || [],
      (d1) => d1.spaceReleased
    )
  );
  let unitsCountForDispatchItems = _.sumBy(
    ActiveData?.items || [],
    (d) => d.quantityDispatched
  );
  const uploadedPicture = _.filter(
    ActiveData?.dispatchEvidences || [],
    (d) => d.typeId === 26
  );
  const uploadeddocument = _.filter(
    ActiveData?.dispatchEvidences || [],
    (d) => d.typeId === 25
  );
  const remarksData = _.orderBy(remarks, ["timeStamp"], ["desc"]);
  const projectManager =
    getIndividualDispatchOrderDataMod?.projectManager || {};
  const depotManager = getIndividualDispatchOrderDataMod?.depotManager || {};
  const address = getIndividualDispatchOrderDataMod?.address || {};
  const raisedBy = getIndividualDispatchOrderDataMod?.raisedBy || {};
  const approvedBy = getIndividualDispatchOrderDataMod?.approvedBy || {};

  const deliveryStatus = [
    { status: "RAISED", date: "13-MAR-23", time: "15:30", name: "Review" },
    { status: "ACCEPTED", date: "13-MAR-23", time: "15:30", name: "Pending" },
    { status: "LOADING", date: "13-MAR-23", time: "15:30", name: "Loading" },
    {
      status: "DEPARTURE",
      date: "13-MAR-23",
      time: "15:30",
      name: "InTransit",
    },
    { status: "DELIVERY", date: "13-MAR-23", time: "15:30", name: "Delivered" },
    {
      status: "CANCELLED",
      date: "13-MAR-23",
      time: "15:30",
      name: "Cancelled",
    },
    {
      status: "DEPARTURE",
      date: "13-MAR-23",
      time: "15:30",
      name: "Dispatched",
    },
  ];

  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    getDispatchOrderInDataFunc();
  }, [id]);

  useEffect(() => {
    statusflag = "#0045D9";
  }, [getIndividualDispatchOrderDataMod]);

  useEffect(() => {
    let updated = { ...rest.getIndividualDispatchOrderData };
    if (updated.deliveryItems) {
      updated.deliveryItems = updated.deliveryItems.map((di) => {
        return {
          ...di,
          condition: lookupValues?.find((lv) => lv.id == di.conditionId)?.name,
        };
      });
      setAddedData(updated);
      _dispatchDetailsData(updated || {});
    }
  }, [rest.getIndividualDispatchOrderData]);

  /** handler functions--------------------------------------------------- **/
  const setAddedData = (Data) => {
    let dispatchItem = [];
    let VehicalData = _.map(Data?.dispatches, (d, key) => {
      if (d.status === "Pending" && !isUpdateShow) {
        setIsUpdateShow(true);
      }
      dispatchItem = [...dispatchItem, ...d.dispatchItems];
      let loadingDateTime = convertIsoToLocalDateTime(
        `${d?.loadingDateTime}.00Z`,
        "DD-MMM-YYYY, HH:mm"
      );
      return {
        ...d,
        tabName: `VEHICLE ${key + 1}`,
        // tabName: `VEHICLE`,
        vehicleRegistration: d?.vehicleRegistration || "",
        departureDate1: d?.departureDate || "",
        vehicleModel: d?.vehicleModel || "",
        internalSpaceReleased: d?.internalSpaceReleased || 0,
        externalSpaceReleased: d?.externalSpaceReleased || 0,
        driverName: d?.driverName || "",
        driverContact: d?.driverContact || "",
        antiSlipMatConfirmedBy: d?.antiSlipMatConfirmedBy || "",
        transitTime: d.transitTime || "",
        receiverName: d.receiverName || "",
        receiverPosition: d.receiverPosition || "",
        receiverPhone: d.receiverPhone || "",
        departureDate: d?.loadingDateTime
          ? new Date(loadingDateTime)
          : new Date(),
        departureTime1: moment(
          new Date(loadingDateTime) || new Date()
        ).hour(),
        departureTime2: moment(
          new Date(loadingDateTime) || new Date()
        ).minute(),
        key: `dispatch${key + 1}`,
        items: [
          ...d.dispatchItems.map((di) => {
            return {
              ...di,
              condition: lookupValues?.find((lv) => lv.id === di.conditionId)
                ?.name,
            };
          }),
        ],
      };
    });
    setVehicalData([...VehicalData]);
    _allDispatchItem([...dispatchItem]);
  };

  const finalDeliveryStatus = () => {
    if (getIndividualDispatchOrderDataMod?.typeValue == "ClientCollection") {
      return _.filter(
        deliveryStatus,
        (d) => !["Cancelled", "Delivered", "InTransit"].includes(d?.name)
      );
    } else if (getIndividualDispatchOrderDataMod?.statusValue == "Cancelled") {
      let filterReq = ["Loading", "InTransit", "Delivered", "Dispatched"];
      let checkAccept =
        _.find(
          getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents || [],
          (d) => d.statusValue == "Pending"
        ) || false;
      if (!checkAccept) {
        return _.filter(
          deliveryStatus,
          (d) => ![...filterReq, "Pending"].includes(d?.name)
        );
      }
      return _.filter(deliveryStatus, (d) => !filterReq.includes(d?.name));
    } else {
      return _.filter(
        deliveryStatus,
        (d) => !["Cancelled", "Dispatched"].includes(d?.name)
      );
    }
  };

  const handleLoadOrderClose = () => {
    _loadOrderModal(!loadOrderModal);
  };

  const handleFinalDeliveredModalClose = () => {
    _finalDeliveredModal(!finalDeliveredModal);
  };

  const handleClose = () => setOpen(false);

  const getDispatchOrderInDataFunc = async () => {
    try {
      let data = await dispatch(getDispatchOrderByIdAction({ id: id || "22" })).unwrap();
      if (!data) {
        toast.error("This Record Not found.")
        navigate("/app/dispatchorders/list")
      }
    } catch (err) {
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const openFullScreen = (image) => {
    setIsFullScreen(true);
    setSelectedImage(image);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
    setSelectedImage(null);
  };

  const handleSubmitRemark = async (data) => {
    try {
      let newData = { ...getIndividualDispatchOrderDataMod };
      let req = {
        id: newData.id,
        apiModule: "DeliveryOrder",
        deliveryOrderRemarks: data?.comments,
        userDetails:
          userDetails?.firstName || "" + " " + userDetails?.lastName || "",
        DeliveryOrderType: getIndividualDispatchOrderDataMod?.typeValue,
        DeliveryOrderNo: newData?.orderNo,
        projectId: newData?.projectId,
      };
      let res = await dispatch(Addremarks(req)).unwrap();
      await getDispatchOrderInDataFunc();
      if (res) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        setShowRemark(false);
        reset();
      }
      toast.success(toastMessages.dispatchOrderRemarks);
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleCancelRemark = () => {
    setShowRemark(!showRemark);
    reset();
  };

  const handleCancelOrderClick = async () => {
    try {
      let newData = { ...getIndividualDispatchOrderDataMod };
      // delete newData.status;
      let req = {
        ...newData,
        id: newData.id,
        projectId: newData?.projectId,
        clientId: newData?.clientId,
        depotId: newData?.depotId,
        orderNo: newData.orderNo,
        projectManagerId: newData?.projectManager?.id,
        dueDate: newData.dueDate,
        dueTime: newData.dueTime,
        ClientName: newData?.clientName,
        statusId: 12,
        deliveryItems: newData.deliveryItems,
        typeId: newData.typeId,
        typeName: getIndividualDispatchOrderDataMod?.typeValue,
        deliveryOrderRemarks: "",
      };

      let res = await dispatch(editDispatchOrder(req)).unwrap();
      await getDispatchOrderInDataFunc();
      if (res) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.dispatchOrderCancel);
        navigate("/app/dispatchorders");
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleApproveRecordClick = async () => {
    try {
      let newData = { ...getIndividualDispatchOrderDataMod };
      // delete newData.status;
      let req = {
        ...newData,
        id: newData.id,
        projectId: newData?.projectId,
        clientId: newData?.clientId,
        depotId: newData?.depotId,
        orderNo: newData.orderNo,
        projectManagerId: newData?.projectManager?.id,
        dueDate: newData.dueDate,
        dueTime: newData.dueTime,
        ClientName: newData?.clientName,
        statusId: 8,
        deliveryItems: newData.deliveryItems,
        typeId: newData.typeId,
        typeName: getIndividualDispatchOrderDataMod?.typeValue,
        deliveryOrderRemarks: "",
        acceptOrder: true
      };
      let res = await dispatch(editDispatchOrder(req)).unwrap();
      await getDispatchOrderInDataFunc();
      if (res) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.dispatchOrderApproved);
        navigate("/app/dispatchorders");
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleDeleteRecordClick = async () => {
    try {
      await dispatch(
        deleteDeliveryOrderRecord({
          id: id,
          orderNo: getIndividualDispatchOrderDataMod?.orderNo || "",
          typeId: getIndividualDispatchOrderDataMod.typeId,
          typeName: getIndividualDispatchOrderDataMod?.typeValue,
          ProjectId: getIndividualDispatchOrderDataMod?.projectId,
        })
      ).unwrap();
      setTimeout(() => {
        dispatch(getAllNofificationForDashboard(1, 20));
      }, 2000);
      toast.success(toastMessages.deliveryOrderRemoved);
      _deleteRecordModal(!deleteRecordModal);
      navigate("/app/dispatchorders/list");
    } catch (error) {
      toast.error(
        GetError(error?.response?.data?.errors) ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  const OnchangeDetailHandler = async (Data) => {
    let cloneVehicalData = _.cloneDeep(vehicalData);
    let GetActiveDataIndex = _.findIndex(
      cloneVehicalData,
      (VehicalItem) => VehicalItem.id === ActiveData.id
    );
    let documentEvidences = Data.deliveryEvidences;
    delete Data.deliveryEvidences;
    cloneVehicalData[GetActiveDataIndex] = {
      ...cloneVehicalData[GetActiveDataIndex],
      ...Data,
      dispatchEvidences: [
        ...cloneVehicalData[GetActiveDataIndex]["dispatchEvidences"],
        ...documentEvidences,
      ],
    };
    let newVehical = _.map(cloneVehicalData, (d) => {
      let temp = { ...d };
      delete temp?.key;
      temp["dispatchId"] = d?.id || null;
      temp["status"] = d?.statusId === 15 ? 15 : d?.statusId || null;
      delete temp?.tabName;
      return temp;
    });

    let newData = {
      deliveryOrderId: dispatchDetailsData?.id || "",
      dispatches: [...newVehical],
    };
    newData.dispatches = _.map(newData?.dispatches, (d, key) => {
      let temp = { ...d };
      let dispatchEvidences = _.map(
        d?.dispatchEvidences,
        (dispatchEvidencesItem) => {
          let temp = { ...dispatchEvidencesItem };
          if (typeof temp.type === "string") {
            temp.type = _.find(
              lookupValues || [],
              (lookupItemp) => lookupItemp.name === temp?.typeId
            )?.id;
            return temp;
          } else {
            return temp;
          }
        }
      );
      temp["dispatchEvidences"] = dispatchEvidences;
      return temp;
    });

    let reqObject = {
      deliveryOrderId: dispatchDetailsData?.id || "",
      dispatchStatus: Data.dispatchStatus,
      depotId: getIndividualDispatchOrderDataMod?.depotId,
      orderNo: getIndividualDispatchOrderDataMod?.orderNo,
      ClientName: getIndividualDispatchOrderDataMod?.clientName,
      projectId: getIndividualDispatchOrderDataMod?.projectId,
      typeName: getIndividualDispatchOrderDataMod?.typeValue,
      dispatches: newData.dispatches.map((v) => {
        return {
          deliveryOrderId: dispatchDetailsData?.id || "",
          id: v.dispatchId ?? 0,
          vrn: v.vrn,
          vehicleModel: v.vehicleModel,
          internalSpaceReleased: v?.internalSpaceReleased || 0,
          externalSpaceReleased: v?.externalSpaceReleased || 0,
          driverName: v.driverName,
          driverContact: v.driverContact,
          description: v.vehicleModel,
          deliveredDate: v?.deliveredDate || null,
          statusId: v.status,
          departureDate: v.departureDate1,
          loadingDateTime: v.loadingDateTime,
          transitTime: v?.transitTime || null,
          onSiteTime: v?.onSiteTime || null,
          receiverName: v?.receiverName,
          receiverPosition: v?.receiverPosition,
          receiverPhone: v?.receiverPhone,
          dispatchItems: v.items.map((item) => {
            return {
              id: item.id ?? 0,
              dispatchId: item.dispatchId ? item.dispatchId : 0,
              itemId: item.itemId,
              deliveryItemId: item.deliveryItemId,
              quantityDispatched: item.quantity
                ? item.quantity
                : item.quantityDispatched
                  ? item.quantityDispatched
                  : 0,
              description: item.description,
              departure: v.departureDate,
              spaceReleased: item.spaceReleased
                ? item.spaceReleased
                : item.space,
            };
          }),
          dispatchEvidences: [...v.dispatchEvidences],
        };
      }),
    };
    setVehicalData([...cloneVehicalData]);
    try {
      let saveData = await dispatch(saveNewLaodInData(reqObject)).unwrap();
      if (saveData) {
        if (userDetails?.roles == "SuperAdmin") {
          setTimeout(() => {
            dispatch(getAllNofificationForDashboard(1, 20));
          }, 2000);
        }
        handleFinalDeliveredModalClose();
        getDispatchOrderInDataFunc();
        toast.success(toastMessages.dispatchItemDelivered);
      }
    } catch (err) {
      // handleFinalDeliveredModalClose();
      toast.error(GetError(err?.response?.data?.errors) || "something issue");
    }
  };

  const handleHoursAndMinutes = (data, type) => {
    let hours = 0;
    let minutes = 0;

    let convertedArray = _.map(data || [], (d) => {
      let temp = "00:00:00";
      if (type == "onSiteTime") {
        temp = d?.onSiteTime || "00:00:00";
      }
      let splitTemp = temp.split(":");
      hours = hours + parseInt(splitTemp[0]);
      minutes = minutes + parseInt(splitTemp[1]);
    });
    if (minutes > 59) {
      let newhours = minutes / 59;
      let splitNewhours = newhours.split(".");
      hours = hours + splitNewhours[0];
      minutes = splitNewhours[1];
    }
    return `${hours ? AddingZeroOnTime(hours) : "00"} : ${minutes ? AddingZeroOnTime(minutes) : "00"
      }`;
  };

  if (getByIdDispatchOrderLoadingState) {
    return <Loader />;
  }
  return (
    <>
      <div
        className={`main-details-div-for-goodsin ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
          }`}
      >
        <div className="row">
          <div
            className="d-flex justify-content-center first-row-details-goodsin-page"
            onClick={() => navigate(-1)}
          >
            <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
              <img src={IconLeftArrow} alt="left arrow" />
            </div>
          </div>
          <div className="goodsin-subdiv-style">
            <div className="ms-2 me-2">
              <div className="row d-flex align-items-center first-row-in-goodsin-details">
                <div className="col-md-5 details-ref-number-style">
                  {getIndividualDispatchOrderDataMod?.orderNo || ""}
                  <span className="ps-2 deliverytext-style text-uppercase">
                    {getIndividualDispatchOrderDataMod?.typeValue == "Delivery"
                      ? "Delivery"
                      : "Collection"}
                  </span>
                </div>
                <div className="col-md-4 col-md-4 d-flex justify-content-end">
                  <span className="d-flex align-items-center goodsin-received-date-text-style">
                    DUE{" "}
                  </span>
                  <span className="details-top-date-text-style ps-2 text-uppercase">
                    {convertIsoToLocalDateTime(`${getIndividualDispatchOrderDataMod?.dueDate?.split("T")[0]}T${getIndividualDispatchOrderDataMod?.dueTime ? getIndividualDispatchOrderDataMod?.dueTime : "00:00:00"}.00Z`, "DD-MMM-YYYY HH:mm")}
                  </span>
                </div>
                <div className="col-md-3 d-flex justify-content-end">
                  <span className="d-flex align-items-center goodsin-received-date-text-style">
                    STATUS{" "}
                  </span>
                  <span
                    className={`text-uppercase goodsin-details-status-color ps-2 ${getIndividualDispatchOrderDataMod.statusValue ==
                      "Review" ||
                      getIndividualDispatchOrderDataMod.statusValue == "Pending"
                      ? "add-dispatch-tbl-red-status-color"
                      : getIndividualDispatchOrderDataMod.statusValue ==
                        "Loading"
                        ? "add-dispatch-tbl-loading-status-color"
                        : getIndividualDispatchOrderDataMod.statusValue ==
                          "Delivered" ||
                          getIndividualDispatchOrderDataMod.statusValue ==
                          "Dispatched"
                          ? "add-dispatch-tbl-green-status-color"
                          : getIndividualDispatchOrderDataMod.statusValue ==
                            "InTransit"
                            ? "add-dispatch-tbl-blue-status-color"
                            : "add-dispatch-tbl-black-status-color"
                      }`}
                  >
                    {getIndividualDispatchOrderDataMod?.statusValue || ""}
                  </span>
                </div>
              </div>

              <div className="d-flex flex-column pt-4 pb-2 add-border-inbetween-class">
                <div className="d-flex flex-row">
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      {" "}
                      CLIENT{" "}
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {" "}
                      {getIndividualDispatchOrderDataMod?.clientName || ""}{" "}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.clientAddress
                        ?.street1 &&
                        getIndividualDispatchOrderDataMod?.clientAddress
                          ?.street1 + ","}{" "}
                      {getIndividualDispatchOrderDataMod?.clientAddress?.city &&
                        getIndividualDispatchOrderDataMod?.clientAddress?.city +
                        ","}{" "}
                      {getIndividualDispatchOrderDataMod?.clientAddress
                        ?.state &&
                        getIndividualDispatchOrderDataMod?.clientAddress
                          ?.state + ","}{" "}
                      {getIndividualDispatchOrderDataMod?.clientAddress
                        ?.country &&
                        getIndividualDispatchOrderDataMod?.clientAddress
                          ?.country + ","}{" "}
                      {getIndividualDispatchOrderDataMod?.clientAddress?.zip &&
                        getIndividualDispatchOrderDataMod?.clientAddress?.zip}
                    </div>
                  </div>
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      PROJECT
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.projectName || ""}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="goodsin-received-date-text-style">
                      PROJECT MANAGER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {projectManager?.firstName} {projectManager?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {projectManager?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {projectManager?.phoneNumber}
                    </div>
                  </div>
                </div>

                <div className="d-flex flex-row mt-3">
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      CONTACT PERSON
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.contactName}
                    </div>
                    <div className="details-goodsin-address-text-style details-text-value-style text-start word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.contactEmail || ""}
                    </div>
                    <div className="details-goodsin-address-text-style details-text-value-style text-start word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.contactPhone || ""}
                    </div>
                  </div>
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      RAISED BY
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {raisedBy?.firstName || ""} {raisedBy?.lastName || ""}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {" "}
                      {raisedBy?.email || ""}
                    </div>
                    <div className="details-goodsin-address-text-style  text-start word-wrap-or-text-wrap">
                      {" "}
                      {raisedBy?.phoneNumber || ""}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="goodsin-received-date-text-style">
                      ACCEPTED BY
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {approvedBy?.firstName} {approvedBy?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {approvedBy?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {approvedBy?.phoneNumber}
                    </div>
                  </div>
                </div>
                <div className="d-flex flex-row mt-3">
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      DELIVERY ADDRESS{" "}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      <div>
                        {address?.street1 || address?.street2}, {address?.city},
                        {address?.state} {address?.country},{address?.zip}
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      DEPOT
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.depotName}
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="goodsin-received-date-text-style">
                      DEPOT MANAGER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {depotManager?.firstName} {depotManager?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {depotManager?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {depotManager?.phoneNumber}
                    </div>
                  </div>
                </div>
              </div>

              <div className="row pt-1">
                <div className="col-md-9 mt-1">
                  <div className="row w-100">
                    {finalDeliveryStatus().map((d, key) => {
                      if (
                        finalDeliveryStatus[key - 1]?.name ===
                        getIndividualDispatchOrderDataMod?.statusValue
                      ) {
                        statusflag = "black";
                      }
                      let eventDate = _.find(
                        getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents,
                        (d1) => d1.statusValue === d?.name
                      )?.eventDate;
                      if (!eventDate && d.name == "Review") {
                        eventDate = _.find(
                          getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents,
                          (d1) => d1.statusValue === "Pending"
                        )?.eventDate;
                      }
                      if (eventDate && d.name == "Pending" && getIndividualDispatchOrderDataMod?.statusValue == "Review") {
                        eventDate = "";
                      }
                      return (
                        <div className="pe-1" style={{ width: "20%" }}>
                          <div className="d-flex justify-content-between align-items-center">
                            <span
                              className=" text-uppercase dispatch-statues-style"
                              style={{ color: statusflag }}
                            >
                              {d.status}
                            </span>
                            <ArrowForwardOutlinedIcon fontSize={"12"} />
                          </div>
                          <span
                            className=" text-uppercase dispatch-statues-date-style"
                            style={{ fontSize: 12 }}
                          >
                            {eventDate ? convertIsoToLocalDateTime(`${eventDate}.00Z`, "DD-MMM-YYYY") : "--"}

                          </span>
                          <div
                            className="dispatch-statues-time-style"
                            style={{ fontSize: 12 }}
                          >
                            {eventDate ? convertIsoToLocalDateTime(`${eventDate}.00Z`, "HH:mm") : "--"}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
                <div
                  className="col-md-3 pt-1"
                  style={{ borderLeft: "1px solid" }}
                >
                  <div className="d-flex flex-row">
                    <div className=" d-flex flex-column ps-1 pe-1 me-2">
                      <div className="dispatch-statues-style text-center">
                        VEHICLES
                      </div>
                      <div className="dispatch-statues-date-style text-center mt-2">
                        {getIndividualDispatchOrderDataMod?.dispatches
                          ?.length || 0}
                      </div>
                    </div>
                    {getIndividualDispatchOrderDataMod?.typeValue == "ClientCollection" ? (
                      ""
                    ) : (
                      <>
                        <div className=" d-flex flex-column ps-1 pe-1">
                          <div className="dispatch-statues-style">
                            ON-SITE (Hrs)
                          </div>
                          <div className="dispatch-statues-date-style text-center mt-2">
                            {handleHoursAndMinutes(
                              getIndividualDispatchOrderDataMod?.dispatches ||
                              [],
                              "onSiteTime"
                            ) || "-- --"}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  paddingTop: 30,
                  justifyContent: "space-between",
                }}
              >
                <div className="req-text-style-for-dispatch-details">
                  REQUIREMENTS
                </div>
                <div className="req-text-style-for-dispatch-details">
                  DISPATCHED
                </div>
              </div>

              <div
                className="row"
                style={{
                  paddingTop: 10,
                  paddingBottom: 20,
                  borderBottom: "1px solid #0146d9",
                  paddingLeft: 10,
                }}
              >
                <table
                  className="table goodsin-table table-borderless p-0"
                  style={{ width: "100%" }}
                >
                  <thead className="goodsin-table-header">
                    <tr style={{ width: "100%" }}>
                      <th
                        className={`text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "25%" }}
                      >
                        <span className="items-table-header-count">
                          {deliveryItems?.length || 0}
                        </span>
                        <div className="items-table-text"> ITEMS</div>
                      </th>
                      <th
                        className={` text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "25%" }}
                      >
                        <span className="items-table-header-count">
                          {damageCount || "-"}
                        </span>
                        <div className="items-table-text"> DAMAGED</div>
                      </th>
                      <th
                        className={`text-uppercase text-primary set-header-width-for-medium-text`}
                        style={{ width: "38%" }}
                      >
                        <span className="items-table-text">DESCRIPTION</span>
                      </th>
                      <th
                        className={`text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "3%" }}
                      >
                        <span className="items-table-header-count">
                          {unitsCount || "-"}
                        </span>
                        <div className="items-table-text"> UNITS</div>
                      </th>
                      <th
                        className={`text-uppercase text-primary set-header-width-for-long-text`}
                        style={{ width: "3%" }}
                      >
                        <div
                          style={{ borderLeft: "1px solid", paddingLeft: 10 }}
                        >
                          <span className="items-table-header-count">
                            {unitsCountForDispatch || "-"}
                          </span>
                          <div className="items-table-text"> UNITS</div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody className="goods-table-body">
                    {dispatchDetailsData?.deliveryItems &&
                      dispatchDetailsData?.deliveryItems.length > 0 &&
                      // dispatchDetailsData?.deliveryItems.map(
                      _.orderBy(
                        dispatchDetailsData?.deliveryItems || [],
                        ["itemNumber"],
                        ["asc"]
                      ).map((itemdata) => {
                        if (itemdata !== null && typeof itemdata === "object") {
                          let findDispatchData = _.filter(
                            allDispatchItem || [],
                            (d) => d?.itemId === itemdata?.itemId
                          );
                          let units =
                            _.sumBy(
                              findDispatchData || [],
                              (d) => d?.quantityDispatched
                            ) || 0;
                          let flag = itemdata?.quantity - units;
                          if (flag > 0 && !checkAllAvailableDataIsDispatched) {
                            setCheckAllAvailableDataIsDispatched(true);
                          }
                          return (
                            <tr
                              className="goodsin-items-tr"
                              style={{ width: "100%" }}
                            >
                              <td style={{ width: "25%" }}>
                                {itemdata?.itemNumber || ""}
                              </td>
                              <td style={{ width: "25%" }}>
                                {itemdata?.condition || ""}
                              </td>
                              <td style={{ width: "38%" }}>
                                {itemdata?.description || ""}
                              </td>
                              <td style={{ width: "3%" }}>
                                {itemdata?.quantity || ""}
                              </td>
                              <td style={{ width: "3%", marginTop: 2 }}>
                                <div
                                  style={{
                                    borderLeft: "1px solid",
                                    paddingLeft: 10,
                                  }}
                                >
                                  {units ? units : "-"}
                                </div>
                              </td>
                            </tr>
                          );
                        } else {
                          return true;
                        }
                      })}
                  </tbody>
                </table>
              </div>

              {Object.keys(ActiveData).length > 0 ? (
                <>
                  <div className="d-flex flex-wrap main-class-for-tabs mb-4 mt-3">
                    {vehicalData.map((d, index) => {
                      return (
                        <React.Fragment key={index}>
                          <div
                            key={index}
                            className={`vehicle-tab-names-style pe-2 ${ActiveIndex == 0 ? "remove-border-for-tab" : ""
                              } ${ActiveData?.tabName == `VEHICLE ${index + 1}`
                                ? "color-change-for-tab"
                                : ""
                              } `}
                            onClick={() => setActiveIndex(index)}
                          >
                            {d.tabName}
                          </div>
                        </React.Fragment>
                      );
                    })}
                  </div>

                  <div className="row">
                    <div className="col-md-3">
                      <TextField
                        className="depot-form-textfields-style textfield-color-class"
                        value={ActiveData?.vrn}
                        id="standard-basic"
                        label="VRN"
                        variant="standard"
                      />
                    </div>
                    <div className="col-md-3">
                      <TextField
                        className="depot-form-textfields-style textfield-color-class"
                        value={ActiveData?.vehicleModel}
                        id="standard-basic"
                        label="VEHICLE TYPE"
                        variant="standard"
                      />
                    </div>
                    <div className="col-md-3">
                      <TextField
                        className="depot-form-textfields-style textfield-color-class"
                        value={ActiveData?.driverName}
                        id="standard-basic"
                        label="DRIVER NAME"
                        variant="standard"
                      />
                    </div>
                    <div className="col-md-3">
                      <TextField
                        className="depot-form-textfields-style textfield-color-class"
                        id="standard-basic"
                        value={ActiveData?.driverContact}
                        label="CONTACT NUMBER"
                        variant="standard"
                      />
                    </div>
                  </div>
                  {ActiveData?.antiSlipMatConfirmedBy && (
                    <div className="row mt-3">
                      <div className="col-md-12 d-flex align-items-end flex-wrap">
                        <span className="me-2" style={{ fontWeight: "bold" }}>
                          I confirm that this lorry has been loaded using anti-slip mats
                        </span>
                        <TextField
                          className="textfield-color-class"
                          value={ActiveData?.antiSlipMatConfirmedBy || ""}
                          id="standard-basic"
                          label="CONFIRMED BY"
                          variant="standard"
                          style={{ width: 250 }}
                        />
                      </div>
                    </div>
                  )}
                  <div className="row mt-3">
                    <div className="col-md-3" style={{ position: "relative" }}>
                      <TextField
                        className="depot-form-textfields-style textfield-color-class"
                        value={ActiveData?.internalSpaceReleased || 0}
                        id="standard-basic"
                        label="INTERNAL"
                        variant="standard"
                      />
                      <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
                    </div>
                    <div className="col-md-3" style={{ position: "relative" }}>
                      <TextField
                        className="depot-form-textfields-style textfield-color-class"
                        value={ActiveData?.externalSpaceReleased || 0}
                        id="standard-basic"
                        label="EXTERNAL"
                        variant="standard"
                      />
                      <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
                    </div>
                  </div>

                  <div className="mt-3">
                    <table className="table goodsin-table table-borderless p-0">
                      <thead>
                        <tr>
                          <th>
                            <span className="items-table-header-count">
                              {ActiveData?.items?.length || 0}
                            </span>
                            <span className="items-table-text"> ITEMS</span>
                          </th>
                          <th>
                            <span className="items-table-header-count">
                              {damageCountForDispatch}
                            </span>
                            <span className="items-table-text"> DAMAGED</span>
                          </th>
                          <th>DESCRIPTION</th>
                          <th>
                            <span className="items-table-header-count">
                              {unitsCountForDispatchItems}
                            </span>
                            <span className="items-table-text"> UNITS</span>
                          </th>

                        </tr>
                      </thead>
                      <tbody className="goods-table-body">
                        {_.orderBy(
                          ActiveData?.items || [],
                          ["itemNumber"],
                          ["asc"]
                        ).map((item, index) => {
                          return (
                            <React.Fragment key={index}>
                              <tr key={index} className="goodsin-items-tr">
                                <td>{item.itemNumber}</td>
                                <td>{item.condition}</td>
                                <td>{item.description}</td>
                                <td>{item.quantityDispatched}</td>
                              </tr>
                            </React.Fragment>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>

                  {uploadedPicture?.length > 0 && (
                    <>
                      <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
                        <InputLabel className="goodsin-form-section-header-name">
                          {" "}
                          {uploadedPicture?.length} PHOTOS
                        </InputLabel>
                      </div>

                      <div className="row">
                        {uploadedPicture?.map((d, index) => {
                          return (
                            <React.Fragment key={index}>
                              <div className="mb-2 pt-2 images-shown-style">
                                <Box
                                  className="image-box-style"
                                  component="img"
                                  alt="The house from the offer."
                                  src={d.url}
                                  style={{ cursor: "pointer" }}
                                  onClick={() => openFullScreen(d.url)}
                                ></Box>
                                {d.isDamaged ? (
                                  <div className="dmg-icon-shown-on-image-style">
                                    <img
                                      height={33}
                                      width={33}
                                      src={IconError}
                                      alt="dmg"
                                    />
                                  </div>
                                ) : null}
                              </div>
                            </React.Fragment>
                          );
                        })}
                      </div>
                    </>
                  )}

                  {isFullScreen && (
                    <div
                      className="full-screen-overlay"
                      onClick={closeFullScreen}
                    >
                      <div className="full-screen-image">
                        <img src={selectedImage} alt="Full-screen Image" />
                      </div>
                    </div>
                  )}

                  {uploadeddocument?.length > 0 && (
                    <>
                      <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
                        <InputLabel className="goodsin-form-section-header-name">
                          {" "}
                          {uploadeddocument?.length} DOCUMENTS
                        </InputLabel>
                      </div>

                      {uploadeddocument.map((d, index) => {
                        return (
                          <div key={index} className="row mt-2">
                            <a href={d.url} target="_blank">
                              <div className="col-md-12">
                                {d?.fileName || "dsd"}
                              </div>
                            </a>
                          </div>
                        );
                      })}
                    </>
                  )}

                  <div className="row justify-content-between mt-4">
                    <div className="col-md-4 d-flex flex-column">
                      <span className="details-departure-style">DEPARTURE</span>

                      <span className="text-uppercase details-departure-status-style text-uppercase">
                        {ActiveData?.statusValue == "Pending"
                          ? ActiveData?.statusValue
                          : ActiveData.departureDate1
                            ? convertIsoToLocalDateTime(`${ActiveData.departureDate1}.000Z`, "DD-MMM-YYYY HH:mm")
                            : "-- --"}
                      </span>
                    </div>
                    {ActiveData?.statusValue === "Delivered" &&
                      getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ? (
                      <>
                        <div className="col-md-4 d-flex flex-column">
                          <span className="details-departure-style text-uppercase">
                            DELIVERED
                          </span>
                          <span className="text-uppercase details-departure-status-style text-uppercase">
                            {ActiveData?.deliveredDate
                              ? convertIsoToLocalDateTime(`${ActiveData.deliveredDate}.00Z`, "DD-MMM-YYYY HH:mm")

                              : "-- --"}
                          </span>
                        </div>

                        <div className="col-md-4 d-flex flex-column">
                          <span className="details-departure-style">
                            ON-SITE (Hrs)
                          </span>
                          <span className="text-uppercase details-departure-status-style">
                            {ActiveData?.onSiteTime
                              ? (ActiveData?.onSiteTime).slice(0, 5)
                              : ""}
                          </span>
                        </div>
                      </>
                    ) : (
                      ""
                    )}

                    <div className="d-flex col-md-8 justify-content-end">
                      {ActiveData?.statusValue === "InTransit" &&
                        getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ? (
                        <Button
                          onClick={handleFinalDeliveredModalClose}
                          className="final-delivered-btn-style"
                        >
                          <img
                            className="me-2"
                            src={IconSubmit}
                            width={15}
                            height={15}
                            alt="alt"
                          />
                          DELIVERED
                        </Button>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>

                  {lookupValues?.find(
                    (v) =>
                      v.id === ActiveData?.status &&
                      v.typeName == "DispatchStatus"
                  )?.name == "InTransit" && (
                      <div className="mt-4 mb-3 add-border-details">
                        <span></span>
                      </div>
                    )}

                  {ActiveData?.statusValue === "Delivered" &&
                    getIndividualDispatchOrderDataMod?.typeValue == "Delivery" && (
                      <div className="row mt-4">
                        <div className="col-md-4 d-flex flex-column">
                          <span className="details-departure-style">
                            RECEIVER
                          </span>
                          <span className="details-departure-status-style">
                            {ActiveData?.receiverName || ""}
                          </span>
                        </div>
                        <div className="col-md-4 d-flex flex-column">
                          <span className="details-departure-style">
                            POSITION
                          </span>
                          <span className="details-departure-status-style">
                            {ActiveData?.receiverPosition || ""}
                          </span>
                        </div>
                        <div className="col-md-4 d-flex flex-column">
                          <span className="details-departure-style">PHONE</span>
                          <span className="details-departure-status-style">
                            {ActiveData?.receiverPhone || ""}
                          </span>
                        </div>
                      </div>
                    )}
                </>
              ) : (
                ""
              )}
              {/* VISIBLE BTN ON  DISPATCH AND DELIVERIED & InTransit ONLY  */}
              {[
                "Delivered",
                "InTransit",
                "Dispatched",
                // "Deleted",
                // "Cancelled",
              ].includes(getIndividualDispatchOrderDataMod?.statusValue) &&
                (userDetails?.roles == "SuperAdmin" ||
                  userDetails?.roles == "Admin") && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      marginTop: 10,
                    }}
                  >
                    <Button
                      variant="outlined"
                      className="download-doc-btn-style"
                      onClick={() => setOpenDocumentModal(true)}
                    >
                      <span style={{ marginRight: 10 }}>
                        <UploadIcon />
                      </span>{" "}
                      UPLOAD DOCUMENTS
                    </Button>
                  </div>
                )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 20,
                }}
              >
                {[
                  "Delivered",
                  "InTransit",
                  "Dispatched",
                  "Pending",
                  "Review",
                  " ",
                  "Loading",
                  // "Cancelled",
                ].includes(getIndividualDispatchOrderDataMod?.statusValue) &&
                  (userDetails?.roles == "SuperAdmin" ||
                    userDetails?.roles == "Admin") && (
                    <div>
                      <Button
                        disabled={
                          getIndividualDispatchOrderDataMod?.statusValue ==
                            "Cancelled"
                            ? true
                            : false
                        }
                        className={`cancel-order-dispatchedit-btn-style ${getIndividualDispatchOrderDataMod?.statusValue ==
                          "Cancelled"
                          ? "add-cancel-order-bg-color"
                          : ""
                          }`}
                        onClick={() => _openCancelModel(!openCancelModel)}
                        variant="outlined"
                      >
                        <img src={IconCancel} height={15} width={15}></img>
                        <span className="ms-2">CANCEL ORDER</span>
                      </Button>

                      {getIndividualDispatchOrderDataMod?.statusValue ==
                        "Delivered" ||
                        getIndividualDispatchOrderDataMod?.statusValue ==
                        " " ||
                        getIndividualDispatchOrderDataMod?.statusValue ==
                        "Dispatched" ? (
                        ""
                      ) : (
                        <Button
                          disabled={
                            getIndividualDispatchOrderDataMod?.statusValue ==
                              "Delivered" ||
                              getIndividualDispatchOrderDataMod?.statusValue ==
                              "Dispatched"
                              ? true
                              : false
                          }
                          className={`ms-2 edit-dispatch-button-style ${getIndividualDispatchOrderDataMod?.statusValue ==
                            "Delivered" ||
                            getIndividualDispatchOrderDataMod?.statusValue ==
                            "Dispatched"
                            ? "add-cancel-order-bg-color"
                            : ""
                            }`}
                          variant="outlined"
                          onClick={async () => {
                            setOpen(!open)
                            await getDispatchOrderInDataFunc();
                          }
                          }
                        >
                          <img
                            src={require("../../../assets/images/edit.png")}
                            height={15}
                            width={15}
                          />
                          <span className="ms-2">EDIT RECORD</span>
                        </Button>
                      )}
                    </div>
                  )}
                {(getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ||
                  getIndividualDispatchOrderDataMod?.typeValue == "ClientCollection")
                  && !["Pending", "Review", "Cancelled"].includes(
                    getIndividualDispatchOrderDataMod?.statusValue
                  ) && (
                    <div className="d-flex justify-content-end">
                      <PDFDownloadLink
                        document={
                          <PrintPdfComponent
                            getIndividualDispatchOrderDataMod={
                              getIndividualDispatchOrderDataMod
                            }
                            activeData={ActiveData}
                            id="detailsId"
                          />
                        }
                        fileName={getIndividualDispatchOrderDataMod?.typeValue == "Delivery" ? "Dispatch-details.pdf" : "Collection-details.pdf"}
                      >
                        {({ blob, url, loading, error }) => {
                          return <Button
                            className="download-doc-btn-style"
                            onClick={() => { }}
                          >
                            <img
                              className="me-2"
                              src={IconDownload}
                              width={15}
                              height={15}
                              alt="alt"
                            />
                            DOWNLOAD DOCUMENTS
                          </Button>
                        }
                        }
                      </PDFDownloadLink>
                    </div>
                  )}
              </div>

              <div style={{ marginTop: 20, border: "1px solid #0146d9" }}></div>

              <div className="d-flex mt-3 justify-content-between mb-3">
                <Button
                  className={`cancel-order-dispatchedit-btn-style ${getIndividualDispatchOrderDataMod?.statusValue ==
                    "Cancelled"
                    ? ""
                    : "add-cancel-order-bg-color"
                    }`}
                  variant="outlined"
                  style={{ marginTop: 15, height: 40 }}
                  onClick={() => _deleteRecordModal(!deleteRecordModal)}
                  disabled={
                    getIndividualDispatchOrderDataMod?.statusValue ==
                      "Cancelled" &&
                      (userDetails?.roles == "SuperAdmin" ||
                        userDetails?.roles == "Admin")
                      ? false
                      : true
                  }
                >
                  <DeleteIcon
                    className="remove-item-icon-color"
                    style={{
                      cursor: "pointer",
                      color:
                        getIndividualDispatchOrderDataMod?.statusValue ==
                          "Cancelled"
                          ? "red"
                          : "gray",
                      fontSize: 20,
                    }}
                  />
                  DELETE RECORD
                </Button>

                {getIndividualDispatchOrderDataMod?.statusValue == "Review" &&
                  (userDetails?.roles == "SuperAdmin" ||
                    userDetails?.roles == "Admin") ? (
                  <Button
                    style={{ marginTop: 15, height: 40 }}
                    className="approved-button-style"
                    onClick={() => _openApprovedModel(!openApprovedModel)}
                    variant="outlined"
                  >
                    <img src={IconApproveDoc} height={15} width={15} />
                    <span className="ms-2">ACCEPT ORDER</span>
                  </Button>
                ) : ![
                  "Delivered",
                  // "InTransit",
                  "Dispatched",
                  "Cancelled",
                  " "
                ].includes(getIndividualDispatchOrderDataMod?.statusValue) &&
                  Object.keys(ActiveData).length > 0 ? (
                  <div className="d-flex justify-content-end mt-3 mb-3">
                    <Button
                      onClick={async () => {
                        _loadOrderModal(!loadOrderModal)
                        await getDispatchOrderInDataFunc();
                      }
                      }
                      variant="outlined"
                      className="edit-dispatch-button-style"
                    >
                      <img
                        src={IconTruckLoad}
                        style={{ height: 20, width: 20 }}
                      />
                      <span className="ms-2">UPDATE</span>
                    </Button>
                  </div>
                ) : getIndividualDispatchOrderDataMod?.statusValue ==
                  "Pending" ? (
                  <div className="d-flex justify-content-end mt-3 mb-3">
                    <Button
                      onClick={async () => {
                        _loadOrderModal(!loadOrderModal)
                        await getDispatchOrderInDataFunc();
                      }
                      }
                      variant="outlined"
                      className="edit-dispatch-button-style"
                    >
                      <img
                        src={IconTruckLoad}
                        style={{ height: 20, width: 20 }}
                      />
                      <span className="ms-2">LOAD ORDER</span>
                    </Button>
                  </div>
                ) : (
                  ""
                )}
              </div>

              <div style={{ height: 100 }}></div>
            </div>
          </div>

          <div className="goodsin-details-remark-section-main-div-style ps-0">
            {showRemark ? (
              <div className="pb-3 add-border-between-remarks-goodsin">
                <div className="pt-2 ms-2 remark-add-div-goodsin-details">
                  <form onSubmit={handleSubmit(handleSubmitRemark)}>
                    <TextField
                      id="outlined-basic"
                      label="Something is being typed here"
                      variant="outlined"
                      multiline
                      {...register("comments")}
                    />
                    {errors.comments ? (
                      <div className=" mt-1 text-danger error-remark-style">
                        {errors.comments?.message}
                      </div>
                    ) : null}
                    <div className="d-flex pt-2 justify-content-end align-items-center">
                      <div
                        className="cursor-style"
                        onClick={handleCancelRemark}
                      >
                        Cancel
                      </div>
                      <div className="ms-2">
                        <Button
                          className="remark-button-bg"
                          type="submit"
                          variant="contained"
                          style={{ background: "#BEBFC2" }}
                        >
                          save
                        </Button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            ) : (
              <div className="leave-remark-main-div">
                <div
                  onClick={() => {
                    setShowRemark(!showRemark);
                  }}
                  className="leave-remark-text-style d-flex align-items-center ps-1 ms-3"
                >
                  Leave remark...
                </div>
              </div>
            )}
            {remarksData?.length > 0 &&
              remarksData?.map((d, index) => {
                return (
                  <div
                    key={index}
                    className="add-border-between-remarks-goodsin"
                  >
                    <div className="p-3 padding-remark-adjust-class">
                      <div className="d-flex">
                        <img
                          style={{ borderRadius: "50%" }}
                          src={d?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                          onError={imgError}
                          className="remark-avatar-style"
                        ></img>
                        <div className="ms-2">
                          <div className="remarkperson--name-shown-style">
                            {d?.firstName || ""} {d?.lastName || ""}{" "}
                          </div>
                          <div className="remarkperson--name-shown-style">
                            {moment(d?.timeStamp || "").format("LT")},
                            {moment(d?.timeStamp || "").format("DD MMM YYYY")}
                          </div>
                        </div>
                      </div>
                      <div className="pt-1 remark-comment-style">
                        {d.comments}
                      </div>
                    </div>
                  </div>
                );
              })}
            <div style={{ height: 100 }}></div>
          </div>
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className="depot-form-header-style">EDIT DISPATCH ORDER</div>
          <DispatchForm
            editData={getIndividualDispatchOrderDataMod}
            handleClose={handleClose}
          />
        </Box>
      </Modal>

      <Modal
        open={openApprovedModel}
        onClose={() => _openApprovedModel(!openApprovedModel)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div>
            <div className="depot-form-header-style">
              <span className="allocate-mgnr-header-color text-uppercase me-2">
                ACCEPT{" "}
                {getIndividualDispatchOrderDataMod?.typeValue == "Delivery"
                  ? "Delivery"
                  : "Collection"}{" "}
                ORDER{" "}
              </span>
              <span className="allocate-mgnr-subheader-color">
                {getIndividualDispatchOrderDataMod?.orderNo}
              </span>
            </div>
            <div style={{ paddingLeft: 100, paddingRight: 100 }}>
              <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span
                  style={{ color: "green" }}
                  className=" common-text-for-removeDepotManager"
                >
                  You are accepting  {" "}
                </span>
                <div className="d-flex">
                  <span className="mb-2">
                    {getIndividualDispatchOrderDataMod?.typeValue == "Delivery"
                      ? "Delivery"
                      : "Collection"}{" "}
                    Order{" "}
                  </span>
                  <span className="common-text-for-removeDepotManager ms-1 mt-1 mb-2">
                    {getIndividualDispatchOrderDataMod?.orderNo || ""}{" "}
                  </span>
                </div>
                <span className="long-text-style-unlist-depot mb-1">
                  This order will now be marked 'PENDING' until further action.{" "}
                </span>
                <div className="d-flex mb-2">
                  <span className="long-text-style-unlist-depot">
                    Depot Managers of{" "}
                  </span>
                  <span className="common-text-for-removeDepotManager space-issue ms-1 me-1 ">
                    {" "}
                    {getIndividualDispatchOrderDataMod?.depot?.name}{" "}
                  </span>
                  <span className="long-text-style-unlist-depot">
                    {" "}
                    can now view this order on their Dashboards.
                  </span>
                </div>
              </div>
              <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                  Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style"
                    startIcon={
                      <img
                        src={IconLeftArrow}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                    onClick={() => _openApprovedModel(!openApprovedModel)}
                  >
                    No, Go Back
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style ms-3"
                    style={{ color: "green", borderColor: "green" }}
                    onClick={() => handleApproveRecordClick()}
                    startIcon={
                      <img
                        src={require("../../../assets/images/approved.png")}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                  >
                    YES, ACCEPT ORDER
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={openCancelModel}
        onClose={() => _openCancelModel(!openCancelModel)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div>
            <div className="depot-form-header-style">
              <span className="allocate-mgnr-header-color text-uppercase me-2">
                CANCEL{" "}
                {getIndividualDispatchOrderDataMod?.typeValue == "Delivery"
                  ? "Delivery"
                  : "Collection"}{" "}
                ORDER{" "}
              </span>
              <span className="allocate-mgnr-subheader-color">
                {getIndividualDispatchOrderDataMod?.orderNo || ""}
              </span>
            </div>
            <div style={{ paddingLeft: 100, paddingRight: 100 }}>
              <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-2">
                  You are cancelling   {" "}
                </span>
                <span className="common-text-for-removeDeliveryOrder mb-2">
                  {getIndividualDispatchOrderDataMod?.typeValue == "Delivery"
                    ? "Delivery"
                    : "Collection"}{" "}
                  Order {" "}
                  <strong>
                    {getIndividualDispatchOrderDataMod?.orderNo || ""}
                  </strong>{" "}
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This order will be marked 'CANCELLED'.{" "}
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This order will not appear on Dashboards.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This order cannot be edited or updated any further.{" "}
                </span>
                {["Loading", "Delivered", "Dispatched"].includes(
                  getIndividualDispatchOrderDataMod?.status
                ) && (
                    <span className="long-text-style-unlist-depot mb-1">
                      There are dispathces against this order.
                    </span>
                  )}
              </div>
              <div className="d-flex flex-column mt-5">
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                  Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style"
                    startIcon={
                      <img
                        src={IconLeftArrow}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                    onClick={() => _openCancelModel(!openCancelModel)}
                  >
                    No, Go Back
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style ms-3"
                    style={{ color: "red", borderColor: "red" }}
                    onClick={handleCancelOrderClick}
                    startIcon={
                      <img
                        src={IconCancel}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                  >
                    YES, CANCEL ORDER
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={loadOrderModal}
        onClose={handleLoadOrderClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <LoadOrderForm
            handleLoadOrderClose={handleLoadOrderClose}
            getIndividualDispatchOrderDataMod={
              getIndividualDispatchOrderDataMod
            }
          />
        </Box>
      </Modal>

      <Modal
        open={finalDeliveredModal}
        onClose={handleFinalDeliveredModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <FinalDeliveryForm
            OnchangeDetailHandler={OnchangeDetailHandler}
            handleFinalDeliveredModalClose={handleFinalDeliveredModalClose}
            activeData={ActiveData}
            getAllDetails={getDispatchOrderInDataFunc}
          />
        </Box>
      </Modal>

      <Modal
        open={deleteRecordModal}
        onClose={() => _deleteRecordModal(!deleteRecordModal)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div>
            <div className="depot-form-header-style">
              <span className="allocate-mgnr-header-color text-uppercase me-2">
                DELETE DELIVERY ORDER
              </span>
              <span className="allocate-mgnr-subheader-color">
                {dispatchDetailsData?.orderNo}
              </span>
            </div>
            <div style={{ paddingLeft: 100, paddingRight: 100 }}>
              <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-2">
                  You are deleting Delivery order.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This record will not appear on dispatch list.
                </span>
              </div>
              <div className="d-flex flex-column mt-5">
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                  Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style"
                    startIcon={
                      <img
                        src={IconLeftArrow}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                    onClick={() => _deleteRecordModal(!deleteRecordModal)}
                  >
                    No, Go Back
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style ms-3"
                    style={{ color: "red", borderColor: "red" }}
                    onClick={handleDeleteRecordClick}
                    startIcon={
                      <img
                        src={IconCancel}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                  >
                    YES, DELETE RECORD
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      <Modal open={openDocumentModel} onClose={handleClosemodal}>
        <Box sx={DocumentModalStyle}>
          <UploadDoc
            toggle={handleClosemodal}
            uploadeddocument={uploadeddocument}
            ActiveData={ActiveData}
            getDispatchOrderInDataFunc={getDispatchOrderInDataFunc}
          />
        </Box>
      </Modal>
    </>
  );
};
